import { observable } from 'mobx';
import type { UserResponseArgs } from './user/user2';
import User, { convertUserResponseToArgs } from './user/user2';

export type ExicCardResponseArgs = {
  id: number;
  organization_id: number;
  exic_number: string;
  password: string;
  users?: UserResponseArgs[];
};

export type ExicCardArgs = {
  id: number;
  organizationId: number;
  exicNumber: string;
  password: string;
  users?: User[];
};

export const convertExicCardResponseToArgs = (response: ExicCardResponseArgs) => {
  const args: ExicCardArgs = {
    id: response.id,
    organizationId: response.organization_id,
    exicNumber: response.exic_number,
    password: response.password,
    users: response.users?.map(user => new User(convertUserResponseToArgs(user)))
  };
  return args;
};

export default class ExicCard {
  @observable id: number;
  @observable organizationId: number;
  @observable exicNumber: string;
  @observable password: string;
  @observable users?: User[];

  constructor(args: ExicCardArgs) {
    this.id = args.id;
    this.organizationId = args.organizationId;
    this.exicNumber = args.exicNumber;
    this.password = args.password;
    this.users = args.users;
  }
}
